export var AuthType;
(function (AuthType) {
    AuthType["Forge"] = "forge";
    AuthType["Auth0"] = "auth0";
})(AuthType || (AuthType = {}));
/**
 * authorizerTokenCookie works for both forge & auth0 flow
 * It is named as auth0.user.token as all the microApps are expecting the token in this legacy cookie name
 */
export const authorizerTokenCookie = 'auth0.user.token';
export const authorizerTokenCookieExpirationDate = 'auth0.user.token.expiry';
export const forgeIdTokenCookie = 'forge.id.token';
export const forgeRefreshTokenCookie = 'forge.refresh.token';
export const forgeAccessTokenExpiration = 'forge.expirationDate';
export const forgeRevalidationCookie = 'forge.revalidation';
export const teamIdCookie = 'teamId';
export const AUTHENTICATION_PROVIDER = 'authentication.provider';
export const FACILITY_WORKSPACE_COOKIE = 'facility.workspace.id';
export const shouldUseRegionPicker = 'region.picker';
export const mockDatesOffsetStorageKey = 'mockDatesOffset';
export var AUTHENTICATION_URL_PARAMS;
(function (AUTHENTICATION_URL_PARAMS) {
    AUTHENTICATION_URL_PARAMS["AUTH0"] = "/login/inno";
    AUTHENTICATION_URL_PARAMS["AUTODESK"] = "/forge/login";
    AUTHENTICATION_URL_PARAMS["PICKER"] = "/login/picker";
    AUTHENTICATION_URL_PARAMS["REGION_PICKER"] = "/region/picker";
})(AUTHENTICATION_URL_PARAMS || (AUTHENTICATION_URL_PARAMS = {}));
const ALMOST_ONE_DAY_IN_MINUTES = 23 * 60;
export const auth0LifeInMinutes = ALMOST_ONE_DAY_IN_MINUTES;
